<script setup lang="ts">
import {
  toRefs,
  computed,
  watch,
  onBeforeMount,
} from 'vue';
import { useRoute } from 'vue-router';
import useStore from '@learner/store';

const route = useRoute();
const store = useStore();
const classes = computed((): object => ({ [`${String(route.name)}-page`]: true }));
const {
  themeClass,
} = toRefs(store);

onBeforeMount(() => {
  const $body = document.querySelector('body');
  if ($body) $body.className = themeClass.value;

  // Reload page if JS files are not found (e.g. after a redeploy).
  window.addEventListener('vite:preloadError', () => {
    window.location.reload();
  });
});

watch(
  themeClass,
  (newVal: string) => {
    const $body = document.querySelector('body');
    if ($body) $body.className = newVal;
  },
);
</script>

<template>
  <div id="app" :class="classes">
    <router-view name="HeaderBar" />
    <router-view/>
  </div>
</template>
